// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Box } from 'grommet'
import { AppsRounded } from 'grommet-icons'

import { AppsMenuContent } from './AppsMenuContent'

const AppsMenu = {
  id: 'apps',
  label: 'Applications menu',
  icon: (
    <Box
      data-testid="apps-btn"
      justify="center"
      align="center"
      round
      height="36px"
      width="36px"
    >
      <AppsRounded color="text-strong" />
    </Box>
  ),
  content: <AppsMenuContent />
}

export { AppsMenu }
